//#region src/errors/access-denied.ts
var e = class extends Error {
	redirect;
	constructor(e) {
		super(), this.name = this.constructor.name, this.redirect = e;
	}
};
//#endregion
export { e as AccessDenied };
